import fetcher, { HTTPMethods } from "../../hooks/fetcher";

export function removeVideoAvatar({ influencerId }) {
  return fetcher(`/api/influencer/${influencerId}`, {
    method: HTTPMethods.PUT,
    body: JSON.stringify({ video_avatar_url: null }),
  });
}
